<template>
    <div class="policy">

        <div class="title-policy">Privacy policy</div>
        <p>respects your privacy. We fully comply with
            the Dutch Data Protection Act (Wet Bescherming Persoonsgegevens) and the Dutch Telecommunications Act
            (Telecommunicatiewet). </p>
        <p>In this Privacy Policy you can read what kind of personal data we collect and how we store, protect and use your
            personal
            data. Furthermore, you can read for which
            purposes we will use your personal data
            and with whom your data will be shared.</p>
        <h3>How do we use your personal data?</h3>

        <div class="personal-data">
            We use the data about your browser language, geolocation in order to address
            <Icon icon="mingcute:add-fill" class="icon" />
        </div>
        <div class="personal-data">
            We use your email address to send you information and updates about your order.
            <Icon icon="mingcute:add-fill" class="icon" />
        </div>

    </div>
</template>
  
<script>
import { Icon } from '@iconify/vue2'

export default {
    name: "Policy",
    components: {
        Icon
    }
}
</script>
  
<style scoped>
.title-policy {
    font-size: 32px;
    font-weight: 600;
    margin-bottom: 10px;
}

h3 {
    font-size: 16px;
    margin-bottom: 16px;
}

p {
    text-align: justify;
    font-size: 16px;
}

.policy {
    padding: 8px;
}

.personal-data {
    display: flex;
    align-items: center;
    justify-items: center;
    background: var(--theme-five);
    border-radius: 8px;
    padding: 12px;
    color: #fff;
    margin-bottom: 8px;
    font-size: var(--font-mini);
    text-align: justify;
}

.icon {
    width: 80px;
    height: 25px;
}
</style>